export default __webpack_public_path__ + "static/media/15.52805b4a.jpg";